/**
 * Sticky Navigation
 * Uses IntersectionObserver to toggle sticky class when scrolling past hero
 * Triggers at SCROLL_TRIGGER_PERCENT of the viewport height
 */

const SCROLL_TRIGGER_PERCENT = 80;

export function initStickyNav() {
  const header = document.getElementById('site-header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const scrollPercent = 100 * scrollTop / viewportHeight;
    header.classList.toggle('nav--sticky', scrollPercent > SCROLL_TRIGGER_PERCENT);
  }, { passive: true });
}

